import { Button, Heading, HStack, Icon, IconButton, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

import { CustomerDetailFullAccount } from '../../../../store/customerDetail/types';
import { InfoPanel } from '../../../CustomerDetail/components/shared/InfoPanel';

export interface SecuritiesTransferDetailHeaderProps {
  onReturn: () => void;
  isMobile: boolean;
  customerLoading: boolean;
  customerError: boolean;
  customerRefresher: () => void;
  customerData: CustomerDetailFullAccount | null | undefined;
}

export const SecuritiesTransferDetailHeader: React.FC<SecuritiesTransferDetailHeaderProps> = ({
  isMobile,
  onReturn,
  customerLoading,
  customerError,
  customerRefresher,
  customerData,
}) => {
  if (isMobile) {
    return (
      <VStack space="stack.nano">
        <HStack justifyContent="space-between">
          <Button
            p={0}
            testID="return-button"
            size={'lg'}
            variant="textLink"
            leftIcon={<Icon name="ArrowLeft" size="xxs" color="neutral.black" />}
            justifyContent="start"
            onPress={onReturn}
            _text={{
              color: 'neutral.black',
              textTransform: 'capitalize',
              pl: 'inline.nano',
              fontSize: Typography['fontsize.lg'],
            }}>
            Transferência de custódia
          </Button>
          <InfoPanel
            isLoading={customerLoading}
            hasError={!!customerError}
            onRefresh={customerRefresher}
            customer={customerData}
            accountSelected={customerData?.additionalAccounts?.[0]}
          />
        </HStack>
      </VStack>
    );
  }

  return (
    <VStack w="full" pt="stack.xs" space="stack.xxs">
      <HStack alignItems="center" space="inline.xxxs">
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          iconColor="brand.tertiary.principal"
          iconSize="xs"
          shadow={3}
          variant="link"
          onPress={onReturn}
        />
        <Heading testId="heading" size="h2">
          Transferência de custódia
        </Heading>
      </HStack>
      <InfoPanel
        isLoading={customerLoading}
        hasError={!!customerError}
        onRefresh={customerRefresher}
        customer={customerData}
        accountSelected={customerData?.additionalAccounts?.[0]}
      />
    </VStack>
  );
};
